import common from "../../common";
import GelHackToggleButton from "../gel/GelHackToggleButton";
import QuestionInputSelect from "./QuestionInputSelect";

export default class QuestionInputSelectSum extends QuestionInputSelect {
    constructor(question, view) {
        super(question, view);
    }

    createOptionButton(value) {
        const a = P3.assets;

        const buttonStates = new P3.ButtonStates();
        buttonStates.normal = a.texture("ui_drop_in_area");
        buttonStates.normalAlt = a.texture("ui_drop_in_area_selected");
        buttonStates.over = a.texture("ui_drop_in_area_highlight");
        buttonStates.over = a.texture("ui_drop_in_area_selected");

        const button = !PIXI.utils.isMobile.any ?
            new GelHackToggleButton(buttonStates) :
            new P3.ToggleButton(buttonStates);

        button.value = value;
        button.animate = false;
        button.animateIcon = false;
        button.tint = common.config.debug && button.value === this._question.answer ? 0x00AA00 : 0xFFFFFF;

        button.overSoundName = "sfx_btn_rollover_00";
        button.clickSoundName = "sfx_btn_press_00";

        button.label = new PIXI.Text(button.value.toString(), {
            fontSize: this._fontSize,
            fontFamily: "Arial",
            fontWeight: "bold",
            fill: 0x0,
            align: "right",
            wordWrap: true
        });
        button.label.position.set(0, 0);
        button.label.anchor.set(0.5, 0.5);
        button.label.resolution = 2;
        button.animation.addChild(button.label);
        return button;
    }

    calculateFontSize(options) {
        const min = 18;
        const max = 24;

        for (let i = 0; i < options.length; ++i) {
            const value = options[i];
            const str = value.toString();
            if (str.length >= 10) {
                return min;
            }
        }
        return max;
    }
}